import { adminApi } from "./adminApi";

export const adminService = {
  async getUsers() {
    const res = await adminApi.get("/users");
    return res.data;
  },

  async getRoles() {
    const res = await adminApi.get("/roles");
    return res.data;
  },

  async createUser(data) {
    const res = await adminApi.post("/users", data);
    return res.data;
  },

  async getCourses() {
    const res = await adminApi.get("/courses");
    return res.data;
  },

  // ⭐ NEW: course detail
  async getCourseDetail(courseId) {
    const res = await adminApi.get(`/courses/${courseId}/detail`);
    return res.data;
  },

  // ⭐ NEW: enroll learner into course
  async enrollLearner(courseId, userId) {
    const res = await adminApi.post(`/courses/${courseId}/enroll`, {
      user_id: userId,
    });
    return res.data;
  },

  async assignSupport(courseId, payload) {
    const res = await adminApi.post(
      `/courses/${courseId}/support`,
      payload
    );
    return res.data;
  },

  async removeSupport(courseId, payload) {
    // axios.delete supports a body via `data`
    const res = await adminApi.delete(`/courses/${courseId}/support`, {
      data: payload,
    });
    return res.data;
  },

  async bulkUpload(courseId, rows) {
    const res = await adminApi.post(`/courses/${courseId}/bulk-upload`, {
      users: rows,
    });
    return res.data;
  },

  // ===========================
  // ⭐ COHORT ADMIN API
  // ===========================
  async getCohorts() {
    const res = await adminApi.get("/cohorts");
    return res.data;
  },

  async createCohort(data) {
    const res = await adminApi.post("/cohorts", data);
    return res.data;
  },

  async getCohortDetail(cohortId) {
    const res = await adminApi.get(`/cohorts/${cohortId}`);
    return res.data;
  },

  async updateCohort(cohortId, payload) {
    const res = await adminApi.patch(`/cohorts/${cohortId}`, payload);
    return res.data;
  },

  async deleteCohort(cohortId) {
    const res = await adminApi.delete(`/cohorts/${cohortId}`);
    return res.data;
  },

  async getCohortUsers(cohortId) {
    const res = await adminApi.get(`/cohorts/${cohortId}/users`);
    return res.data;
  },

  async enrollIntoCohort(cohortId, userId, role = "learner") {
    const res = await adminApi.post(`/cohorts/${cohortId}/enroll`, {
      user_id: userId,
      role_in_cohort: role,
    });
    return res.data;
  },

  async removeFromCohort(cohortId, userId) {
    const res = await adminApi.delete(`/cohorts/${cohortId}/users/${userId}`);
    return res.data;
  },

  async deleteUserTransactions(userId) {
    const res = await adminApi.delete(`/users/${userId}/transactions`);
    return res.data;
  },

  async getWaitlist(params = {}) {
    const res = await adminApi.get("/waitlist", { params });
    return res.data;
  },

  async getWaitlistWhatsapp(params = {}) {
    const res = await adminApi.get("/waitlist/whatsapp", { params });
    return res.data;
  },

  async downloadWaitlistWhatsappCsv(params = {}) {
    const res = await adminApi.get("/waitlist/whatsapp.csv", {
      params,
      responseType: "blob",
    });
    return res.data;
  },

  async downloadWaitlistWhatsappVcf(params = {}) {
    const res = await adminApi.get("/waitlist/whatsapp.vcf", {
      params,
      responseType: "blob",
    });
    return res.data;
  },

  async sendWaitlistEmail(payload) {
    const res = await adminApi.post("/waitlist/send-email", payload);
    return res.data;
  },

  async deleteWaitlistUser(waitlistUserId, confirmRelated = false) {
    const res = await adminApi.delete(`/waitlist/${waitlistUserId}`, {
      params: confirmRelated ? { confirm_related: true } : undefined,
    });
    return res.data;
  },

  async getWaitlistBotSession(waitlistId) {
    const res = await adminApi.get(`/waitlist-bot-sessions/by-waitlist/${waitlistId}`, {
      baseURL: process.env.REACT_APP_BACKEND_API_URL,
    });
    return res.data;
  },

  async getPromotionFlowSession(waitlistId) {
    const res = await adminApi.get(`/waitlist/${waitlistId}/promotion-flow`);
    return res.data;
  },

  async getUserProgressSummary(userId) {
    const res = await adminApi.get(`/users/${userId}/progress-summary`);
    return res.data;
  },

  async getAccountabilityBookings(params = {}) {
    const res = await adminApi.get("/accountability-bookings", { params });
    return res.data;
  },

  async getAccountabilityBookingDetail(bookingId) {
    const res = await adminApi.get(`/accountability-bookings/${bookingId}`);
    return res.data;
  },

  async getAccountabilityBookingSettings() {
    const res = await adminApi.get("/accountability-bookings/settings");
    return res.data;
  },

  async updateAccountabilityBookingSettings(payload) {
    const res = await adminApi.patch("/accountability-bookings/settings", payload);
    return res.data;
  },

  async getPaymentSettings() {
    const res = await adminApi.get("/payment-settings");
    return res.data;
  },

  async updatePaymentSettings(payload) {
    const res = await adminApi.patch("/payment-settings", payload);
    return res.data;
  },

  async getConsultationBookings() {
    const res = await adminApi.get("/consultation-bookings");
    return res.data;
  },

  async getPaymentDiscountCodes() {
    const res = await adminApi.get("/payment-discount-codes");
    return res.data;
  },

  async createPaymentDiscountCode(payload) {
    const res = await adminApi.post("/payment-discount-codes", payload);
    return res.data;
  },

  async updatePaymentDiscountCode(codeId, payload) {
    const res = await adminApi.patch(`/payment-discount-codes/${codeId}`, payload);
    return res.data;
  },
};
